var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M25,42.8642578c-8.4257812,0-15.28125-6.8554688-15.28125-15.28125 c0-5.0839844,2.5185547-9.8208008,6.7363281-12.6704102c0.4560547-0.3085938,1.0800781-0.1884766,1.3876953,0.2685547 c0.3095703,0.4580078,0.1894531,1.0795898-0.2685547,1.3886719C13.9082031,19.046875,11.71875,23.1640625,11.71875,27.5830078 c0,7.3232422,5.9580078,13.28125,13.28125,13.28125s13.28125-5.9580078,13.28125-13.28125 c0-4.4248047-2.1943359-8.5449219-5.8691406-11.0214844c-0.4580078-0.3085938-0.5791016-0.9296875-0.2705078-1.3876953 s0.9316406-0.5791016,1.3876953-0.2705078c4.2275391,2.8486328,6.7519531,7.5883789,6.7519531,12.6796875 C40.28125,36.0087891,33.4257812,42.8642578,25,42.8642578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M25,22.6357422c-0.5527344,0-1-0.4477539-1-1v-13.5c0-0.5522461,0.4472656-1,1-1s1,0.4477539,1,1v13.5 C26,22.1879883,25.5527344,22.6357422,25,22.6357422z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.342b5a4f2a1429bee875ce48ef4b0b33.svg";
export { ForwardRef as ReactComponent };